const userState = {
    VERIFIED: 'verified',
    REJECTED: 'rejected',
    NEW: 'new'
}
export default userState
